<template>
    <app-wrapper>
        <app-header :loan="loan" medium-max-width="max-w-1000">
            <template #top>
                <div class="w-full flex items-center">
                    <div class="flex-auto">
                        Your desired loan amount
                        <h2 class="mb-0 mt-2 md:mt-4 md:text-6xl">{{ loan.amount | money(0) }}</h2>
                    </div>
                    <div class="flex-initial">
                        <i class="fa fa-check-circle text-success text-7xl" />
                    </div>
                </div>
            </template>
            <template #navigation>
                <div class="flex justify-between items-center">
                    <div class="w-full max-w-200">
                        <h5 data-testid="title" class="font-zen-dots text-white">
                            <AppLogo />    
                        </h5>
                    </div>
                </div>
            </template>
        </app-header>
        <app-body medium-max-width="max-w-1000">
            <template #title> We need to verify your address </template>

            <template #text>
                
                <div class="mt-6 shadow-floating bg-white rounded-lg relative z-10 mb-8 border-bottom">
                    <div class="flex flex-col md:flex-row md:items-center justify-center">
                        <div class="w-full">
                            <div
                                class="flex flex-col md:flex-row md:flex-wrap items-center app-header-top p-7 md:py-10 md:px-14"
                            >
                                <div class="w-full app-header-top">
                                    <div class="w-full flex flex-col items-center">
                                        
                                        <template v-if="page === 'verify-address'">
                                            <div class="w-full flex flex-col items-center">
                                                <div class="text-lg text-center font-medium">
                                                    <p class="">Have you ever lived in one of these addresses?</p>
                                                </div>
                                                <div class="border-2 border-zinc-200 rounded-lg shadow-floating p-4 mt-4 w-full max-w-lg">
                                                    <div v-for="address in addresses_to_show" :key="address.address" class="flex items-center space-x-2 mt-2">
                                                        <input type="radio" :id="address.value" :name="address.value" :value="address.value" v-model="choose_address" />
                                                        <label :for="address.value">{{ address.address }}</label>
                                                    </div>
                                                </div>
                                                <transition name="slide">
                                                    <div v-if="error_address_validation" class="text-red-500 text-sm mt-2">
                                                        {{ error_address_validation }}
                                                    </div>
                                                </transition>
                                                <button
                                                    data-testid="confirm-address"
                                                    @click="changeQuestion"
                                                    v-if="choose_address !== null"
                                                    class="mt-4 bg-orange-400 hover:bg-orange-500 text-white font-medium px-4 py-2 rounded"
                                                >
                                                    <span v-if="loading">
                                                        <i class="fa fa-spinner fa-spin mr-2" />
                                                        <span>Processing...</span>
                                                    </span>
                                                    <span v-else>
                                                        <span>Confirm</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </template>

                                        <template v-if="page === 'confirm-address'">
                                            <div class="w-full flex flex-col items-center">
                                                <div class="text-lg text-center font-medium">
                                                    <p class="">Is this your current address?</p>
                                                </div>
                                                <div>
                                                    <p class="p-4 my-6 bg-[#3e8086] text-white border-zinc-500 rounded-md">{{ getLastAddressInReport() }}</p>
                                                </div>
                                                <div class="border rounded-lg shadow-floating p-4 mt-4 w-full max-w-lg">
                                                    <label class="flex items-center space-x-2">
                                                        <input type="radio" name="address" :value="true" v-model="confirm_address" />
                                                        <span class="font-medium"><span class="font-semibold">Yes</span>, please use this as my current address</span>
                                                    </label>
                                                    <label class="flex items-center space-x-2 mt-2">
                                                        <input type="radio" name="address" :value="false" v-model="confirm_address" />
                                                        <span><span class="font-semibold">No</span>, my current address is {{ getUserAddress() }}</span>
                                                    </label>
                                                </div>
                                                <transition name="slide">
                                                    <div v-if="error_address_validation" class="text-red-500 text-sm mt-2">
                                                        {{ error_address_validation }}
                                                    </div>
                                                </transition>
                                                <button
                                                data-testid="save-address"
                                                    @click="confirmAddress"
                                                    class="mt-4 bg-orange-400 hover:bg-orange-500 text-white font-medium px-4 py-2 rounded"
                                                >
                                                    <span v-if="loading">
                                                        <i class="fa fa-spinner fa-spin mr-2" />
                                                        <span>Processing...</span>
                                                    </span>
                                                    <span v-else>
                                                        <span>Save</span>
                                                    </span>
                                                </button>
                                            </div>
                                        </template>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </app-body>
    </app-wrapper>
</template>

<script>

import AppLogo from './../../../components/AppLogo.vue'; 
import { analytics } from './../../../analytics';

export default {
    
    props: ['loan', 'lastaddressinreport'],

    components: {
        AppLogo
    },

    data() {
        return {
            loading: false,
            choose_address: null,
            error_address_validation: null,
            confirm_address: null,
            page: 'verify-address',
            gTagPageName: 'ADDRESS_VERIFICATION',
            addresses_to_show: [],
            correct_address: 'microbilt',
            fake_addresses: [
                '1234 Main St, Anytown, CA 12345',
                '5678 Market St, Springfield, IL 62701',
                '9101 Broadway St, Metropolis, NY 10001',
                '2345 Center St, Gotham, NJ 07001',
                '6789 Park Ave, Star City, CA 90210',
                '3456 Main St, Central City, TX 73301',
                '7890 Elm St, Coast City, FL 33101',
                '4567 Oak St, Keystone City, PA 19101',
                '8901 Pine St, Blüdhaven, GA 30301',
                '5678 Maple St, Fawcett City, OH 44101',
                '9101 Cedar St, Midway City, MI 48201',
                '2345 Birch St, Hub City, MA 02101',
                '6789 Spruce St, Ivy Town, IN 46201',
                '3456 Walnut St, Smallville, KS 66501',
                '7890 Cherry St, Happy Harbor, RI 02801',
                '4567 Peach St, Riverdale, OR 97001',
                '8901 Plum St, Duckburg, WA 98101',
                '5678 Pear St, St. Canard, CO 80201',
                '9101 Apple St, Spoonerville, AZ 85001',
                '2345 Orange St, Cape Suzette, NV 89501',
                '6789 Lemon St, Mouseton, UT 84101',
                '3456 Lime St, Duckburg, ID 83701',
                '7890 Grape St, St. Canard, MT 59001',
                '4567 Banana St, Spoonerville, WY 82001',
                '8901 Strawberry St, Cape Suzette, NM 87501',
                '5678 Raspberry St, Mouseton, ND 58101',
                '9101 Blueberry St, Duckburg, SD 57101',
                '2345 Blackberry St, St. Canard, NE 68101',
                '6789 Cranberry St, Spoonerville, OK 73101',
                '3456 Boysenberry St, Cape Suzette, AR 72201',
                '7890 Kiwi St, Mouseton, LA 70101',
                '4567 Mango St, Duckburg, MS 39201',
                '8901 Papaya St, St. Canard, AL 35201',
                '5678 Pineapple St, Spoonerville, TN 37201',
                '9101 Watermelon St, Cape Suzette, KY 40201',
                '2345 Cantaloupe St, Mouseton, WV 25301',
                '6789 Honeydew St, Duckburg, DE 19901'
            ]
        };
    },

    methods: {

        getUserAddress() {
            const user = this.loan?.user ?? null;

            if(!user) {
                return '-';
            }

            const address2 = user?.address2 ? `, ${user.address2}` : '';

            if(user) {
                return `${user.address} ${address2}, ${user.city}, ${user.state} ${user.zip}`;
            }

            return '-';
        },

        setErrorValidation(message = 'Please select an option')
        {
            this.error_address_validation = message;
            this.loading = false;
            setTimeout(() => {
                this.error_address_validation = null;
            }, 5000);
        },

        changeQuestion() 
        {
            if(this.choose_address !== this.correct_address) {
                this.confirm_address = false;
                this.go();
                return;
            }
            
            this.page = 'confirm-address';
            analytics.marketPlaceSignUpEvents.addressVerificationChangePage({
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user?.id ?? null,
                choosed_address: this.choose_address,
                correct_address: this.correct_address
            });
        },

        confirmAddress()
        {
            if(this.confirm_address === null) {
                this.setErrorValidation();
                return;
            }

            this.go();
        },

        go() {
            
            this.loading = true;
            this.error_address_validation = false;

            let address = this.addresses_to_show.filter(address => address.value == this.choose_address)[0].address;

            analytics.marketPlaceSignUpEvents.addressVerificationConfirmAddress({
                loan_id: this.loan?.id ?? null,
                loan_status: this.loan?.status ?? null,
                user_id: this.loan?.user?.id ?? null,
                choosed_address: this.choose_address,
                correct_address: this.correct_address,
                confirm_address: this.confirm_address,
            });
            
            this.$http
                .post(`/signup/welcome/${this.loan.id}`, {
                    confirm_address: this.confirm_address,
                    chosen_address: address
                })
                .then((response) => {
                    window.location.reload();
                })
                .catch((error) => {
                    this.setErrorValidation(error?.response?.data?.message ?? 'An error occurred');
                    console.error(error);
                    analytics.marketPlaceSignUpEvents.addressVerificationConfirmAddressError({
                        loan_id: this.loan?.id ?? null,
                        loan_status: this.loan?.status ?? null,
                        user_id: this.loan?.user?.id ?? null,
                        choosed_address: this.choose_address,
                        correct_address: this.correct_address,
                        confirm_address: this.confirm_address,
                        error: error?.response?.data?.message ?? 'An error occurred'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getLastAddressInReport() {
            return this.lastaddressinreport;
        },

        setAddressToShow() {

            const microbiltAddress = {
                address: this.getLastAddressInReport(),
                value: this.correct_address
            };
            
            const randomAddresses = this.fake_addresses
                .sort(() => 0.5 - Math.random())
                .slice(0, 3)
                .map((address, index) => ({ address, value: `fake_${index + 1}` }));
            

            this.addresses_to_show = [
                microbiltAddress,
                ...randomAddresses
            ].sort(() => 0.5 - Math.random());

            this.addresses_to_show = this.addresses_to_show.map(address => {
                const addressParts = address.address.split(' ');
                addressParts.shift();
                return {
                    ...address,
                    address: addressParts.join(' ')
                };
            });

            this.addresses_to_show.push({ address: 'None of the above', value: 'none' });
        },

        trackAddressChange(newAddress, oldAddress) {
            analytics.marketPlaceSignUpEvents.changeAddressEvent({
                page_name: this.gTagPageName,
                new_address: newAddress,
                old_address: oldAddress,
                loan_id: this.loan?.id ?? null,
                user_id: this.loan?.user?.id ?? null,
                loan_status: this.loan?.status ?? null,
            })
        },

        trackConfirmAddressChange(confirm) {
            analytics.marketPlaceSignUpEvents.confirmAddressEvent({
                page_name: this.gTagPageName,
                confirm: confirm,
                loan_id: this.loan?.id ?? null,
                user_id: this.loan?.user?.id ?? null,
                loan_status: this.loan?.status ?? null,
            })
        }
    },

    watch: {
        choose_address(newAddress, oldAddress) {
            this.trackAddressChange(newAddress, oldAddress);
        },
        confirm_address(confirm) {
            this.trackConfirmAddressChange(confirm);
        }
   },

    created() {
        this.setAddressToShow();
    },
};
</script>

<style scoped>
    .slide-enter-active, .slide-leave-active {
        transition: transform 0.5s;
    }
    .slide-enter, .slide-leave-to {
        transform: translateY(5px);
    }
</style>